module.exports = __webpack_public_path__ + "static/img/换电柜.ee0072bc.png";